import { DATA_TYPE, MAX_LENGTH } from "../../../../../constants/external-constants";
import DATEPICKER_OR from "../../../../common/custom-form/custom-date-picker.component";
import { InputFieldFloatingLabel as InputField } from "../../../../common/custom-form/select-filter.component";
const Polkomtel = (props) => {
  let decimalPlaceholder;
  
    if(props?.inputType === DATA_TYPE.decimal){
        decimalPlaceholder = "0.00";
    }
  return (
    <>
        <DATEPICKER_OR
          dateOnly={true}
          label={props.Datelabel}
          startDate={props.startDate || null}
          selectedDate={props.selectedDate}
          placeholder={props.placeholder}
          requiredField={true}
        />

        <InputField
            className="form-control"
            type="text"
            label={props.CreditLabel}
            value={props?.invoiceUploadForm}
            inputType={props?.inputType}
            fieldProp='invoiceUploadForm.fanChargesAndCredits'
            maxLength={MAX_LENGTH.limit_255}
            placeholder={decimalPlaceholder != null ? decimalPlaceholder : props.placeholderInvoiceNumber}         
            hasNegativeValue={true}
        />
    </>
  );
};

export default Polkomtel;
